import React, {useState, createRef} from 'react';
import {Formik, Field, FormikProps} from 'formik';
import classNames from 'classnames';
import {Link} from 'react-router-dom';

import {Layouts, Button, Form, ReCaptcha} from '@components';
import paths from '@paths';
import utils from '@utils';
import validations from '@validations';
import {Props} from './types';
import * as handlers from './handlers';

import './index.scss';

const Contact: React.FC<Props> = props => {
  const recaptchaRef = createRef();

  const isAuthed = !!props.me.sub;
  const initialValues = {
    name: isAuthed ? `${props.me.lastName} ${props.me.firstName}` : '',
    email: isAuthed ? props.me.email : '',
    message: '',
  };
  const [reCaptchaToken, setReCaptchaToken] = useState(null);

  return (
    <div className={classNames('a__contact', {after: isAuthed})}>
      {!isAuthed && (
        <Layouts.Header.Before
          history={props.history}
          location={props.location}
          match={props.match}
        />
      )}
      <div className="w__contact-header">
        <div className="b__title-header">お問い合わせ</div>
        <div>
          ご質問や機能不具合がございましたら、下記よりお気軽にご連絡ください。
        </div>
      </div>
      <div className="b__contact">
        <div className="w__contact-form">
          <Formik
            initialValues={initialValues}
            onSubmit={(value: any, formikAction: any) =>
              handlers.sendContact(
                value,
                formikAction,
                props.me,
                reCaptchaToken,
                recaptchaRef
              )
            }
            validate={validations.contact.main}
          >
            {(formProps: FormikProps<any>) => {
              return (
                <>
                  <div className="b__information">
                    <div className="w__contact-input">
                      <Form.Label text="名前" required={!isAuthed} />
                      <Field
                        component={Form.Input}
                        placeholder="名前"
                        maxLength={20}
                        name="name"
                        disabled={formProps.isSubmitting || isAuthed}
                      />
                    </div>
                    <div className="w__contact-input">
                      <Form.Label text="メールアドレス" required={!isAuthed} />
                      <Field
                        component={Form.Input}
                        placeholder="メールアドレス"
                        maxLength={50}
                        name="email"
                        disabled={formProps.isSubmitting || isAuthed}
                      />
                    </div>
                    <div className="w__contact-input">
                      <Form.Label text="お問い合わせ内容" required />
                      <Field
                        component={Form.TextArea}
                        placeholder="お問い合わせ"
                        name="message"
                        disabled={formProps.isSubmitting}
                      />
                    </div>
                  </div>

                  <div className="w__recaptcha">
                    <ReCaptcha
                      ref={recaptchaRef}
                      onChange={(value: any) => {
                        utils.reCaptcha.submit(value, setReCaptchaToken);
                      }}
                    />
                    <Form.Error>
                      {utils.reCaptcha.error(
                        formProps.submitCount,
                        reCaptchaToken
                      )}
                    </Form.Error>
                  </div>

                  <Button.Normal
                    text="送信する"
                    color="yellow"
                    rounded={true}
                    className="b__contact-button"
                    large
                    onClick={() => {
                      formProps.handleSubmit();
                    }}
                    disabled={formProps.isSubmitting}
                    loading={formProps.isSubmitting}
                  />
                </>
              );
            }}
          </Formik>
        </div>
        <div className="b__attention">
          <div>
            <span className="asterisk">*</span>
            AnpiCheckerの使用方法についてのお問い合わせはお答え致しかねます。
          </div>

          <div>
            よくある質問は
            <Link to={paths.questions.main}>
              <b>こちら</b>
            </Link>
            からご確認頂けます。
          </div>
        </div>
      </div>
      {!isAuthed && <Layouts.Footer.Main />}
    </div>
  );
};

export default Contact;
